import React, { Fragment } from "react";
import Header from "../components/Header";

import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PageHeader from "../components/PageHeader";
import Jobs from "../components/Jobs";
import JobListings from "../components/Jobs/JobListings";


const JobsPage = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/jobsection-1.jpg")}
        title="Unlock your future"
        content=""
      />
      <Jobs />
      <JobListings />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default JobsPage;
